<template>
	<div class="headerModuleWrap">
		<div class="headerWrap">
			<div class="header-module">
				<!-- <img class="arrow-btn" @click="back2Prev" :src="`${imgPath}/static/assets/img/arrow.png`" /> -->
				<div class="arrow-btn"></div>
				<div class="logo" :style="{ width: width + 'rem' }">
					<img :src="logo || `${imgPath}/static/assets/img/logo.png`" width="100%" />
				</div>
				<div class="menu-btn" @click="drawer=!drawer">
					<img v-if="!drawer" :src="`${imgPath}/static/assets/img/button.png`" width="100%" />
					<img v-else :src="`${imgPath}/static/assets/img/header-close.png`" width="100%" />
				</div>
			</div>
		</div>
		<el-drawer
			:visible.sync="drawer"
			direction="ttb"
			:with-header="false"
			class="menuClass"
			custom-class="menuContent">
			<div class="menuWrap">
				<a class="menuItem" href="/">{{ $t('menu.index') }}</a>
				<div>
					<div class="collapse menuItem">
						<span>{{ $t('menu.brand') }}</span>
						<!-- <i class="menuCollapseIcon" :class="{close:showSubMenu}"><img :src="`${imgPath}/static/assets/img/menu-close.png`" /></i> -->
					</div>
					<div class="subMenuWrap subShowTab">
						<a class="submenuItem" href="/wap/brand1">{{ $t('brand.hla') }}</a>
						<a class="submenuItem" href="/wap/brand4">{{ $t('brand.hla_heans') }}</a>
						<a class="submenuItem" href="/wap/brand2">{{ $t('brand.ovv') }}</a>
						<!-- <a class="submenuItem" href="/wap/brand5">{{ $t('brand.heylads') }}</a> -->
						<a class="submenuItem" href="/wap/brand7">{{ $t('brand.yeehoo') }}</a>
						<a class="submenuItem" href="/wap/brand6">{{ $t('brand.hla_f2c') }}</a>
						<!-- <a class="submenuItem" href="/wap/brand3">{{ $t('brand.hla_home') }}</a> -->
					</div>
				</div>
				<a class="menuItem" href="/wap/notice">{{ $t('menu.investor') }}</a>
				<a class="menuItem" href="/wap/news">{{ $t('menu.news') }}</a>
				<a class="menuItem" href="http://www.hotjob.cn/wt/HLA/web/index?brandCode=100001">{{ $t('menu.hr') }}</a>
				<a class="menuItem" @click="changeLang"><span class="blod">{{language == 'zh-cn'?'中文':'ENG'}}</span> / <span>{{language !== 'zh-cn'?'中文':'ENG'}}</span></a>
				<div style="font-size: 0.28rem; margin-top: 0.2rem;">
					<p>{{ $t('menu.serveice') }}</p>
					<p>suggest@hla.com</p>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		name:'Header',
		props: {
			logo: {
				type: String,
				default: ''
			},
			width: {
				type: Number,
				default: 2.69
			}
		},
		data() {
			return {
				drawer:false,
				showSubMenu:false,
				language: this.$route.query.lang || localStorage.getItem('language')||'zh-cn'
			}
		},
		watch:{
			$route: {
				handler() {
					location.reload();
				},
				deep: true,
			}
		},
		mounted(){
			let locale = this.$route.query.lang||localStorage.getItem('language')||'zh-cn';
			this.$i18n.locale=locale;//改变当前语言
			localStorage.setItem('language',locale);
		},
		methods: {
			back2Prev() {
				this.$router.go(-1);
			},
			changeLang() {
				let locale = localStorage.getItem('language')||'zh-cn';
				let temp=locale === 'zh-cn' ? 'en-us' : 'zh-cn';
				this.$i18n.locale=temp;//改变当前语言
				localStorage.setItem('language',temp);
				let path = this.$router.history.current.path
				this.$router.push({ path, query: {lang:temp} });
			},
		}
	}
</script>
<style>
	.menuContent{
		height: 100% !important;
	}
	.menuClass{
		z-index: 2 !important;
	}
	.v-modal{
		z-index: 1 !important;
	}
</style>
<style lang="scss" scoped>
.headerModuleWrap {
	position: relative;
	z-index: 12;
}
	.headerWrap{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		height: 0.9rem;
  		background:rgba(0, 0, 0, 0.89);
		z-index: 111;
	}
	.header-module{
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		height: 0.9rem;
		padding: 0 0.3rem;
		box-sizing: border-box;
		.arrow-btn{
			width: 0.23rem;
			height: 0.39rem;
		}
		.menu-btn{
			width: 0.45rem;
			height: 0.31rem;
			cursor: pointer;
		}
		.logo{
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
			width: 1.7rem;
			overflow: hidden;
		}
	}
	.menuWrap{
		width: 7.5rem;
		height: 100vh;
		background: #FFFFFF;
		padding: 0.9rem 0.75rem 0;
		box-sizing: border-box;
		z-index: 11;
		.menuItem{
			display: block;
			font-size: 0.28rem;
			padding: 0.3rem 0 0.2rem;
			font-weight: 600;
			color: #161A1A;
			border-bottom: 1px solid #CCCCCC;
			>span{
				&.blod{
					font-weight: bold;
				}
			}
		}
		.collapse{
			display: flex;
			align-items: center;
			justify-content: space-between;
			.menuCollapseIcon{
				display: block;
				width: 0.2rem;
				height: 0.2rem;
				&.close {
					>img {
						transform: rotate(0);
					}
				}
				>img {
					width: 100%;
					transform: rotate(-45deg);
					transition: all ease 0.1s;
				}
			}
		}
		.subMenuWrap{
			padding-left: 0.63rem;
			transition: height 0.4s;
			overflow: hidden;
			height:0;
			&.subShowTab {
				height:4.4rem;
				border-bottom: 1px solid #CCCCCC;
			}
			.submenuItem{
				display: block;
				font-size: 0.26rem;
				color: #161A1A;
				font-weight: 400;
				line-height: 0.5rem;
				margin: 0.32rem 0;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/header.vue